import { Card, CardContent, Tooltip, withStyles, withTheme } from '@material-ui/core';
import { Box, Checkbox, Typography } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  DELETE_CLIENT_CONTACT_FAILURE,
  GET_CLIENT_CONTACTS_FAILURE,
  POST_CLIENT_CONTACT_FAILURE,
  UPDATE_CLIENT_CONTACT_FAILURE
} from '../../types';
import { deleteClientContact, getClientContacts, postClientContact, updateClientContact } from '../../clients.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import ClientContactsCustomTable from './clientContactsCustomTable.component';
import Spinner from 'modules/common/spinner.component';
import { useState } from 'react';

const styles = theme => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    accordionStyleContacts: {
      maxWidth: 1050
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryText: {
      paddingTop: 2,
      paddingRight: 5,
      marginRight: 16
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050
    }
  };
};

const ClientContactsTable = props => {
  const { clientContacts, clientDivisions, enumerations } = props;

  const [isLoading, setIsLoading] = useState(false);

  const addressTypes =
    enumerations.addressTypes && enumerations.addressTypes.length > 0
      ? enumerations.addressTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  // const contactTypes =
  //   enumerations.contactTypes && enumerations.contactTypes.length > 0
  //     ? enumerations.contactTypes.filter(s => s.isActive === true)
  //     : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const contactStatuses =
    enumerations.contactStatuses && enumerations.contactStatuses.length > 0
      ? enumerations.contactStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const countries =
    enumerations && enumerations.countries && enumerations.countries.length > 0
      ? enumerations.countries.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const provinces =
    enumerations && enumerations.provinces && enumerations.provinces.length > 0
      ? enumerations.provinces.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const filteredDivisions =
    clientDivisions && clientDivisions.length > 0
      ? clientDivisions
          .filter(s => s.clientRecordId === props.clientRecordId)
          .map(d => {
            return { id: d.clientDivisionId, title: d.divisionName };
          })
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const currentSelectedDivisions = useMemo(() => {
    if (Array.isArray(clientDivisions)) {
      return filteredDivisions
        .filter(f => clientDivisions.some(x => x.clientDivisionId === f.clientDivisionId))
        .map(f => ({ id: f.clientDivisionId, title: f.divisionName }));
    }
    return [];
  }, [clientDivisions, filteredDivisions]);

  // const vendorSearchInfo = vendors => {
  //   return {
  //     searchingColumns: [
  //       { name: 'vendorId', title: 'Vendor Id' },
  //       { name: 'companyName', title: 'Company Name' },
  //       { name: 'city', title: 'City' },
  //       { name: 'state', title: 'State' },
  //       { name: 'phone', title: 'Company Phone' },
  //       { name: 'email', title: 'Company Email' }
  //     ],
  //     searchingColumnExtensions: [
  //       { columnName: 'vendorId', width: 150 },
  //       { columnName: 'companyName', width: 250 },
  //       { name: 'city', width: 175 },
  //       { name: 'state', width: 175 },
  //       { columnName: 'phone', width: 175 },
  //       { columnName: 'email', width: 175 }
  //     ],
  //     searchingRows: vendors,
  //     idKey: 'vendorId',
  //     nameKey: 'companyName'
  //   };
  // };

  let filteredContacts =
    clientContacts && clientContacts.length > 0
      ? clientContacts.map(contact => {
          return {
            clientContactId: contact.contact.clientContactId,
            clientRecordId: props.clientRecordId,
            firstName: contact.contact.firstName,
            lastName: contact.contact.lastName,
            jobTitle: contact.contact.jobTitle,
            isPrimaryContact: contact.contact.isPrimaryContact,
            addressId: contact.address.addressId,
            officeEmail: contact.contact.officeEmail,
            officePhone: contact.contact.officePhone,
            contactStatus: contact.contact.contactStatus,
            contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
            vendorId: null,
            hasRelosourceAccess: contact.contact.hasRelosourceAccess,
            hasRelosourceReportsAccess: contact.contact.hasRelosourceReportsAccess,
            isAuthorizer: contact.contact.isAuthorizer,
            isPullsToInvoice: contact.contact.isPullsToInvoice,
            hasExceptionApprovalRouting: contact.contact.hasExceptionApprovalRouting,
            hasIndustryInfo: contact.contact.hasIndustryInfo,
            hasCompanyNews: contact.contact.hasCompanyNews,
            hasOnlineAuthNotifications: contact.contact.hasOnlineAuthNotifications,
            shouldReceiveClientSurvey: contact.contact.shouldReceiveClientSurvey,
            hasOnlineExpenseReportNotifications: contact.contact.hasOnlineExpenseReportNotifications,
            addressTypeId: contact.address.addressTypeId,
            addressLine1: contact.address.addressLine1,
            addressLine2: contact.address.addressLine2,
            addressLine3: contact.address.addressLine3,
            city: contact.address.city,
            county: contact.address.county,
            provinceId: contact.address.provinceId ? contact.address.provinceId : '00000000-0000-0000-0000-000000000000',
            countryId: contact.address.countryId ? contact.address.countryId : '00000000-0000-0000-0000-000000000000',
            zipcode: contact.address.zipcode,
            contactDivisions: Array.isArray(contact.contactDivisions)
              ? contact.contactDivisions.map(d => {
                  const match = filteredDivisions.find(fd => fd.id === (d.id || d.clientDivisionId));
                  return match ? match : { id: d.id || d.clientDivisionId, title: '' };
                })
              : [],
            hasConfidentialFileAccess: contact.contact.hasConfidentialFileAccess
          };
        })
      : [];

  const adjustedColumns = [
    {
      accessorKey: 'firstName',
      header: 'First Name',
      type: 'text',
      required: true,
      size: 70,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      accessorKey: 'lastName',
      header: 'Last Name',
      type: 'text',
      required: true,
      size: 70,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      accessorKey: 'jobTitle',
      header: 'Job Title',
      type: 'text',
      required: true,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    { accessorKey: 'isPrimaryContact', header: 'Primary Contact', type: 'checkbox', hideInTable: true },
    {
      accessorKey: 'officeEmail',
      header: 'Work Email',
      type: 'text',
      required: true,
      size: 80,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      accessorKey: 'officePhone',
      header: 'Work Phone',
      type: 'text',
      required: true,
      size: 60,
      enableColumnActions: false,
      enableColumnDragging: false,
      enableResizing: false,
      hideInTable: true
    },
    {
      header: 'Divisions',
      accessorKey: 'contactDivisions',
      type: 'multi-select-v2',
      options: filteredDivisions,
      required: true,
      value: currentSelectedDivisions,
      tab: 1,
      hideInTable: true,
      Cell: ({ cell }) => {
        const divs = cell.getValue();
        if (!Array.isArray(divs)) return '';
        return divs.map(d => d.title || '').filter(Boolean).join(', ');
      }
    },
    {
      accessorKey: 'contactStatus',
      header: 'Status',
      type: 'dropdown-v2',
      options: contactStatuses,
      required: true,
      enableColumnDragging: false,
      enableResizing: false,
      hideInTable: true
    },
    { header: 'Address Type', accessorKey: 'addressTypeId', type: 'dropdown-v2', options: addressTypes, hideInTable: true },
    { accessorKey: 'addressLine1', header: 'Work Address 1', type: 'text', hideInTable: true },
    { accessorKey: 'addressLine2', header: 'Work Address 2', type: 'text', hideInTable: true },
    { accessorKey: 'city', header: 'Work City', type: 'text', hideInTable: true },
    { accessorKey: 'county', header: 'Work County', type: 'text', hideInTable: true },
    { header: 'State', accessorKey: 'provinceId', type: 'dropdown-v2', hideInTable: true, options: provinces },
    { header: 'Country', accessorKey: 'countryId', type: 'dropdown-v2', hideInTable: true, options: countries },
    { accessorKey: 'zipcode', header: 'Work Postal Code', type: 'text', hideInTable: true },

    { accessorKey: 'hasRelosourceAccess', header: 'ReloSource Access?', type: 'checkbox', Cell: ({ cell }) => <Checkbox checked={!!cell.row.original.hasRelosourceAccess} disabled /> },
    // { accessorKey: 'hasRelosourceReportsAccess', header: 'RS Reporting Access?', type: 'checkbox', hideInTable: true, hideInModel: true },
    // { accessorKey: 'isAuthorizer', header: 'Authorizer', type: 'checkbox', hideInTable: true, hideInModel: true },
    // { accessorKey: 'isExceptionApprover', header: 'Exception Approver', type: 'checkbox', hideInTable: true, hideInModel: true },
    { accessorKey: 'isPullsToInvoice', header: 'Pulls to Invoices?', type: 'checkbox', hideInTable: true },
    { accessorKey: 'hasExceptionApprovalRouting', header: 'Exception Approval Routing', type: 'checkbox', hideInTable: true },
    { accessorKey: 'hasIndustryInfo', header: 'Industry Info?', type: 'checkbox', hideInTable: true },
    { accessorKey: 'hasCompanyNews', header: 'Company News?', type: 'checkbox', hideInTable: true },
    { accessorKey: 'hasOnlineAuthNotifications', header: 'Online Auth Notifications', type: 'checkbox', hideInTable: true },
    { accessorKey: 'shouldReceiveClientSurvey', header: 'Receives Client Survey', type: 'checkbox', hideInTable: true },
    // { accessorKey: 'hasOnlineExpenseReportNotifications', header: 'Auth Approval Routing', type: 'checkbox', hideInTable: true, hideInModel: true },
    // { accessorKey: 'hasConfidentialFileAccess', header: 'Confidential File Access', type: 'checkbox', hideInTable: true , hideInModel: true}
  ];

  const getPrimaryContact = clientContacts => {
    return clientContacts.find(contact => contact.primaryContact === true);
  };

  const displayPrimaryContact = clientContacts => {
    let primaryContact = getPrimaryContact(clientContacts);
    if (primaryContact) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <h3 className={props.classes.primaryText}>Primary Contact:</h3>
          <Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                First Name
              </Typography>
            </Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                {primaryContact.firstName}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                Last Name
              </Typography>
            </Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                {primaryContact.lastName}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                Office Phone
              </Typography>
            </Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                {primaryContact.officePhone}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                Office Email
              </Typography>
            </Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                {primaryContact.officeEmail}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                Job Title
              </Typography>
            </Box>
            <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                {primaryContact.jobTitle}
              </Typography>
            </Box>
          </Box>
        </Box>
      );
    }
  };

  const updateRow = async (contact, values) => {
    const id = contact.original.clientContactId;
    const addressId = contact.original.addressId;

    setIsLoading(true);

    let divisions = values.contactDivisions.filter(d => d.id || d.clientDivisionId).map(d => {
      return { clientDivisionId: d.id || d.clientDivisionId };
    });

    let newValues = {
      contact: {
        clientContactId: id,
        clientRecordId: props.clientRecordId,
        firstName: values.firstName,
        lastName: values.lastName,
        jobTitle: values.jobTitle,
        addressId: addressId,
        isPrimaryContact: values.isPrimaryContact && values.isPrimaryContact !== '' ? values.isPrimaryContact : false,
        officeEmail: values.officeEmail,
        officePhone: values.officePhone,
        contactStatus: values.contactStatus,
        contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
        vendorId: null,
        hasRelosourceAccess: values.hasRelosourceAccess,
        hasRelosourceReportsAccess: false,
        isAuthorizer: false,
        isPullsToInvoice: values.isPullsToInvoice,
        hasExceptionApprovalRouting: values.hasExceptionApprovalRouting,
        hasIndustryInfo: values.hasIndustryInfo,
        hasCompanyNews: values.hasCompanyNews,
        hasOnlineAuthNotifications: values.hasOnlineAuthNotifications,
        shouldReceiveClientSurvey: values.shouldReceiveClientSurvey,
        hasOnlineExpenseReportNotifications: false,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date(),
        isExceptionApprover: false,
        hasConfidentialFileAccess: false
      },
      address: {
        addressId: addressId,
        addressTypeId: values.addressTypeId,
        addressLine1: values.addressLine1 ? values.addressLine1 : '',
        addressLine2: values.addressLine2 ? values.addressLine2 : '',
        addressLine3: values.addressLine3 ? values.addressLine3 : '',
        city: values.city ? values.city : '',
        county: values.county ? values.county : '',
        provinceId: values.provinceId ? values.provinceId : '00000000-0000-0000-0000-000000000000',
        countryId: values.countryId ? values.countryId : '00000000-0000-0000-0000-000000000000',
        zipcode: values.zipcode ? values.zipcode : ''
      },
      contactDivisions: divisions
    };

    const resp = await props.updateClientContact(newValues);
    if (resp.type === UPDATE_CLIENT_CONTACT_FAILURE) {
      props.showToast('Failed to update contact, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getClientContacts(props.clientRecordId);
      if (getResp.type === GET_CLIENT_CONTACTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        filteredContacts = getResp.response.map(contact => {
          return {
            clientContactId: contact.contact.clientContactId,
            clientRecordId: props.clientRecordId,
            firstName: contact.contact.firstName,
            lastName: contact.contact.lastName,
            jobTitle: contact.contact.jobTitle,
            isPrimaryContact: contact.contact.isPrimaryContact,
            addressId: contact.address.addressId,
            officeEmail: contact.contact.officeEmail,
            officePhone: contact.contact.officePhone,
            contactStatus: contact.contact.contactStatus,
            contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
            vendorId: null,
            hasRelosourceAccess: contact.contact.hasRelosourceAccess,
            hasRelosourceReportsAccess: false,
            isAuthorizer: false,
            isPullsToInvoice: contact.contact.isPullsToInvoice,
            hasExceptionApprovalRouting: contact.contact.hasExceptionApprovalRouting,
            hasIndustryInfo: contact.contact.hasIndustryInfo,
            hasCompanyNews: contact.contact.hasCompanyNews,
            hasOnlineAuthNotifications: contact.contact.hasOnlineAuthNotifications,
            shouldReceiveClientSurvey: contact.contact.shouldReceiveClientSurvey,
            hasOnlineExpenseReportNotifications: false,
            isExceptionApprover: false,
            addressTypeId: contact.address.addressTypeId,
            addressLine1: contact.address.addressLine1,
            addressLine2: contact.address.addressLine2,
            addressLine3: contact.address.addressLine3,
            city: contact.address.city,
            county: contact.address.county,
            provinceId: contact.address.provinceId ? contact.address.provinceId : '00000000-0000-0000-0000-000000000000',
            countryId: contact.address.countryId ? contact.address.countryId : '00000000-0000-0000-0000-000000000000',
            zipcode: contact.address.zipcode,
            contactDivisions: contact.contactDivisions,
            hasConfidentialFileAccess: false
          };
        });
        const successMsg = values.hasRelosourceAccess
          ? 'Contact updated successfully and ReloSource access provisioned successfully.'
          : 'Contact updated successfully.';
        props.showToast(successMsg, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        setIsLoading(false);
        return true;
      }
    }
  };

  const createRow = async values => {
    let divisions = values.contactDivisions.map(d => {
      return { clientDivisionId: d.id };
    });

    setIsLoading(true);

    let newValues = {
      contact: {
        clientRecordId: props.clientRecordId,
        firstName: values.firstName,
        lastName: values.lastName,
        jobTitle: values.jobTitle,
        isPrimaryContact: values.isPrimaryContact && values.isPrimaryContact !== '' ? values.isPrimaryContact : false,
        officeEmail: values.officeEmail,
        officePhone: values.officePhone,
        contactStatus: values.contactStatus,
        contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
        vendorId: null,
        hasRelosourceAccess: values.hasRelosourceAccess && values.hasRelosourceAccess !== '' ? values.hasRelosourceAccess : false,
        hasRelosourceReportsAccess: false,
        isAuthorizer: false,
        isPullsToInvoice: values.isPullsToInvoice && values.isPullsToInvoice !== '' ? values.isPullsToInvoice : false,
        hasExceptionApprovalRouting:
          values.hasExceptionApprovalRouting && values.hasExceptionApprovalRouting !== '' ? values.hasExceptionApprovalRouting : false,
        hasIndustryInfo: values.hasIndustryInfo && values.hasIndustryInfo !== '' ? values.hasIndustryInfo : false,
        hasCompanyNews: values.hasCompanyNews && values.hasCompanyNews !== '' ? values.hasCompanyNews : false,
        hasOnlineAuthNotifications:
          values.hasOnlineAuthNotifications && values.hasOnlineAuthNotifications !== '' ? values.hasOnlineAuthNotifications : false,
        shouldReceiveClientSurvey:
          values.shouldReceiveClientSurvey && values.shouldReceiveClientSurvey !== '' ? values.shouldReceiveClientSurvey : false,
        hasOnlineExpenseReportNotifications: false,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date(),
        isExceptionApprover: false,
        hasConfidentialFileAccess:  false
      },
      address: {
        addressTypeId: '67a86dee-2aa4-4975-9df0-95368dfec694',
        addressLine1: values.addressLine1 ? values.addressLine1 : '',
        addressLine2: values.addressLine2 ? values.addressLine2 : '',
        addressLine3: values.addressLine3 ? values.addressLine3 : '',
        city: values.city ? values.city : '',
        county: values.county ? values.county : '',
        provinceId: values.provinceId ? values.provinceId : '00000000-0000-0000-0000-000000000000',
        countryId: values.countryId ? values.countryId : '00000000-0000-0000-0000-000000000000',
        zipcode: values.zipcode ? values.zipcode : ''
      },
      contactDivisions: divisions
    };

    const resp = await props.postClientContact(newValues);
    if (resp.type === POST_CLIENT_CONTACT_FAILURE) {
      props.showToast('Failed to create contact, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getClientContacts(props.clientRecordId);
      if (getResp.type === GET_CLIENT_CONTACTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        filteredContacts = getResp.response.map(contact => {
          return {
            clientContactId: contact.contact.clientContactId,
            clientRecordId: props.clientRecordId,
            firstName: contact.contact.firstName,
            lastName: contact.contact.lastName,
            jobTitle: contact.contact.jobTitle,
            isPrimaryContact: contact.contact.isPrimaryContact,
            addressId: contact.address.addressId,
            officeEmail: contact.contact.officeEmail,
            officePhone: contact.contact.officePhone,
            contactStatus: contact.contact.contactStatus,
            contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
            vendorId: null,
            hasRelosourceAccess: contact.contact.hasRelosourceAccess,
            hasRelosourceReportsAccess: contact.contact.hasRelosourceReportsAccess,
            isAuthorizer: contact.contact.isAuthorizer,
            isPullsToInvoice: contact.contact.isPullsToInvoice,
            hasExceptionApprovalRouting: contact.contact.hasExceptionApprovalRouting,
            hasIndustryInfo: contact.contact.hasIndustryInfo,
            hasCompanyNews: contact.contact.hasCompanyNews,
            hasOnlineAuthNotifications: contact.contact.hasOnlineAuthNotifications,
            shouldReceiveClientSurvey: contact.contact.shouldReceiveClientSurvey,
            hasOnlineExpenseReportNotifications: contact.contact.hasOnlineExpenseReportNotifications,
            addressTypeId: contact.address.addressTypeId,
            addressLine1: contact.address.addressLine1,
            addressLine2: contact.address.addressLine2,
            addressLine3: contact.address.addressLine3,
            city: contact.address.city,
            county: contact.address.county,
            provinceId: contact.address.provinceId ? contact.address.provinceId : '00000000-0000-0000-0000-000000000000',
            countryId: contact.address.countryId ? contact.address.countryId : '00000000-0000-0000-0000-000000000000',
            zipcode: contact.address.zipcode,
            contactDivisions: contact.contactDivisions,
            hasConfidentialFileAccess: contact.contact.hasConfidentialFileAccess
          };
        });
        const successMsg = values.hasRelosourceAccess
          ? 'Contact created successfully and ReloSource access provisioned successfully.'
          : 'Contact created successfully.';
        props.showToast(successMsg, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        setIsLoading(false);
        return true;
    }
  };
}

  const deleteRow = async contact => {
    const id = contact.original.clientContactId;
    setIsLoading(true);
    const resp = await props.deleteClientContact(id);
    if (resp.type === DELETE_CLIENT_CONTACT_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContacts(props.clientRecordId);
      if (getResp.type === GET_CLIENT_CONTACTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        filteredContacts = getResp.response.map(contact => {
          return {
            clientContactId: contact.contact.clientContactId,
            clientRecordId: props.clientRecordId,
            firstName: contact.contact.firstName,
            lastName: contact.contact.lastName,
            jobTitle: contact.contact.jobTitle,
            isPrimaryContact: contact.contact.isPrimaryContact,
            addressId: contact.address.addressId,
            officeEmail: contact.contact.officeEmail,
            officePhone: contact.contact.officePhone,
            contactStatus: contact.contact.contactStatus,
            contactType: '5507e8dd-4432-4ab0-8e23-2561ae4fb13d',
            vendorId: null,
            hasRelosourceAccess: contact.contact.hasRelosourceAccess,
            hasRelosourceReportsAccess: contact.contact.hasRelosourceReportsAccess,
            isAuthorizer: contact.contact.isAuthorizer,
            isPullsToInvoice: contact.contact.isPullsToInvoice,
            hasExceptionApprovalRouting: contact.contact.hasExceptionApprovalRouting,
            hasIndustryInfo: contact.contact.hasIndustryInfo,
            hasCompanyNews: contact.contact.hasCompanyNews,
            hasOnlineAuthNotifications: contact.contact.hasOnlineAuthNotifications,
            shouldReceiveClientSurvey: contact.contact.shouldReceiveClientSurvey,
            hasOnlineExpenseReportNotifications: contact.contact.hasOnlineExpenseReportNotifications,
            addressTypeId: contact.address.addressTypeId,
            addressLine1: contact.address.addressLine1,
            addressLine2: contact.address.addressLine2,
            addressLine3: contact.address.addressLine3,
            city: contact.address.city,
            county: contact.address.county,
            provinceId: contact.address.provinceId ? contact.address.provinceId : '00000000-0000-0000-0000-000000000000',
            countryId: contact.address.countryId ? contact.address.countryId : '00000000-0000-0000-0000-000000000000',
            zipcode: contact.address.zipcode,
            contactDivisions: contact.contactDivisions,
            hasConfidentialFileAccess: contact.contact.hasConfidentialFileAccess
          };
        });
        setIsLoading(false);
        return true;
      }
    }
  };

  const validateEmail = email => {
    return (
      !!email.length &&
      email
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    );
  };

  const customValidator = (cell, value) => {
    return cell.column.columnDef.type === 'email' ? validateEmail(value) : true;
  };
  console.log(clientContacts)
  console.log(filteredContacts)

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Tooltip title={'File Contract'} key={'clientContacts'} placement="right">
            <FontAwesomeIcon icon={['fas', 'phone']} size="2x" />
          </Tooltip>
          <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
            Contacts
          </Typography>
        </Box>
        <div className={props.classes.newRow}>{displayPrimaryContact(filteredContacts)}</div>
        {!isLoading && (
          <ClientContactsCustomTable
            editingMode={'modal'} // Can be changed to 'row' to edit inline
            columns={adjustedColumns}
            rows={filteredContacts ? filteredContacts : []}
            updateRow={updateRow}
            createRow={createRow}
            deleteRow={deleteRow}
            customValidator={customValidator}
            countriesEnum={countries}
            provincesEnum={provinces}
            initialState={{
              columnFilters: [
                {
                  id: 'status',
                  value: 'A'
                }
              ]
            }}
          />
        )}
        {isLoading && <Spinner />}
      </CardContent>
    </Card>
  );
};

ClientContactsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  clientContactsLoading: PropTypes.bool,
  clientRecordId: PropTypes.number,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  postClientContact: PropTypes.func,
  updateClientContact: PropTypes.func,
  getClientContacts: PropTypes.func,
  deleteClientContact: PropTypes.func,
  clientContacts: PropTypes.array,
  showToast: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { clientContactsLoading } = state.clients;
  return {
    clientContactsLoading
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getClientContacts,
    deleteClientContact,
    postClientContact,
    updateClientContact,
    showToast
  })
)(ClientContactsTable);
